//行业方案
import React from "react";
import industrySolutions from '../Home/img/IndustryBanner.png'

import solution1 from '../Home/img/solution1.jpg'
import '../CSS/style.css'
import {Col, Divider, Row} from "antd";
import {scrollToTop} from "../Utils/CommonFunc";
import {Link} from "react-router-dom";
import Education from "../Home/img/Education.png";
import Hospital from "../Home/img/Hospital.png";
import Traffic from "../Home/img/traffic.png";
import Consumption from "../Home/img/consumption.png";
import Government from "../Home/img/government.png";
import industry1 from "../Home/img/industry1.png";
import Industry from "../Home/img/Industry.png";
import traffic from "../Home/img/traffic.png";
import consumption from "../Home/img/consumption.png";
import government from "../Home/img/government.png"
import {titleSize, subtitleSize, contentSize, contentColor, subSubTitleSize} from "../Utils/CommonVar"

export default class IndustrySolutions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          indusList: [],
        }
    }

    componentWillMount() {
        scrollToTop(0);
        this.getIndustrySolution();
    }

    componentDidMount() {
      if(this.props.location.state) {
        setTimeout(() => {
          const name = this.props.location.state.name;
          let height = 0;
          if (name === '医疗领域') {
            height = document.getElementById("hospital1").getBoundingClientRect().top;//getBoundingClientRect()用于获取某个元素相对于视窗的位置
          }else if (name === '教育领域') {
            height = document.getElementById("eduction1").getBoundingClientRect().top;
          }else if (name === '交通领域') {
            height = document.getElementById("transport1").getBoundingClientRect().top;
          }else if (name === '消费服务') {
            height = document.getElementById("consume1").getBoundingClientRect().top;
          }else if (name === '政府服务') {
            height = document.getElementById("government1").getBoundingClientRect().top;
          }
          scrollToTop(height - 100);
        }, 300)
      }else {
        scrollToTop(0);
      }
    }

  getIndustrySolution = () => {
        const indusList = [
            {
                id:'hospital1',
                imageUrl: Hospital,
                title:"医疗领域",
                des:"智慧医疗协同服务",
                detail:["医患协同：常慢病管理、单病种全周期、健康管理","医院协同：远程诊疗、远程病理、协同转诊",
                    "医企协同：电子处方云、静脉配置中心、院内物流中心"],
                // path:"/education"
            },  {
                id:'eduction1',
                imageUrl: Education,
                title:"教育领域",
                des:"高校教学管理服务 ",
                detail:["本科实验教学管理系统","基于微信端教学评价系统","本科毕业设计管理系统","研究生创新创业服务平台"],
                // path:"/education"
            }, {
                id:'transport1',
                imageUrl: Traffic,
                title:"交通领域",
                des:"公共交通客流分析",
                detail:["轨道客流大数据分析应用","公交客流大数据分析应用", "公共交通区域出行分析应用"],
                // path:"/education"
            }, {
                id:'consume1',
                imageUrl: Consumption,
                title:"消费服务",
                des:"人像摄影智能服务",
                detail:["影像后期服务平台", "精准营销服务平台"],
                // path:"/education"
          }, {
                id: 'government1',
                imageUrl: Government,
                title:"政府服务",
                des:"城市综合管理服务 ",
                detail:["消防综合执法系统","社区综合治理系统"],
                // path:"/education"
          },
        ]
        this.setState({indusList})
    }
    render() {
        const width = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) - 17;
        const height = width / 4;
        const {indusList} = this.state;
        const IndusHTML = indusList.map((item, index)=> {
          const evenable = (index%2 ==0) ? true : false;
            const liList = item.detail.map((item1, index1) => (
                <li className='blacks' key={index1}>{item1}</li>
            ));
            const imgContainer = <Row type="flex" align="middle">
              <img src={item.imageUrl} alt='picture' width='300px'/>
            </Row>
          const liContainer = <div style={{lineHeight: 2}}>
              <p style={{fontSize: titleSize, color: contentColor, cursor:'pointer'}} className="titleCss">{item.title}</p>
              <p style={{color: contentColor, fontSize:subSubTitleSize}}>{item.des}</p>
              <ul style={{color: '#999', fontSize:16, listStyle: 'none'}}>
                {liList}
              </ul>
            </div>
            //style={{ justifyContent: !evenable ? 'flex-start' : 'flex-end'}}
            return (
                <div key={index} id={item.id}>
                    <Row style={{margin: 30}} align="middle" gutter={50}  style={{ display: 'flex', flexDirection: evenable ? 'row' : 'row-reverse'}}>
                      <Col span={8}>{imgContainer}</Col>
                      {
                        evenable ? <Col span={16} className="li-container" >{liContainer}</Col>
                          :
                          <Col span={8} offset={8} className="li-container" >{liContainer}</Col>
                      }

                      {/*<Col span={16} className="li-container" >{liContainer}</Col>*/}
                    </Row>
                  <Divider/>
                </div>
            )
            }
        )
        return(
            <div style={{marginTop:72}}>
                <div style={{maxHeight:474, position: 'relative', zIndex: 2}}>
                    <img src={industrySolutions} alt="picture" width={width} height={height}/>
                </div>
                <div style={{background:"#F2F6F9"}}>
                    <div className="all" style={{width:1200}}>
                        <Row style={{padding: '64px 60px'}}>
                          <div>
                            <Row style={{display: 'flex', justifyContent: 'center', fontSize:titleSize,textAlign:"center",color:contentColor,fontWeight:500,lineHeight:1.5}}>
                              行业应用
                            </Row>
                            <Row style={{display: 'flex', justifyContent: 'center', fontSize:subtitleSize,textAlign:"center",color:contentColor,lineHeight:1.5,marginBottom:20,}}>
                              Industry Application
                            </Row>
                            <Row style={{display: 'flex', justifyContent: 'center', fontSize:contentSize,textAlign:"center",color:'#999',lineHeight:1.5, marginBottom:48}}>
                              行业应用涵盖5大领域
                            </Row>
                          </div>
                            <Row type="flex" align="middle" style={{ lineHeight:2,textIndent:30, fontSize: 20,padding:0 }}>
                              <img src={industry1} alt='picture' width='100%' height='100%'/>
                            </Row>
                        </Row>
                    </div>
                </div>
              <div style={{background:"#fff"}}>
                <div className='all' style={{maxWidth: 1200,padding: 60}}>
                  {IndusHTML}
                </div>
              </div>
            </div>
        )
    }
}
